import { dew as _toBytesDew } from "../encoding/toBytes.js";
import { dew as _toHexDew } from "../encoding/toHex.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.compactSignatureToSignature = void 0;
  const toBytes_js_1 = _toBytesDew();
  const toHex_js_1 = _toHexDew();
  function compactSignatureToSignature({
    r,
    yParityAndS
  }) {
    const yParityAndS_bytes = (0, toBytes_js_1.hexToBytes)(yParityAndS);
    const v = yParityAndS_bytes[0] & 128 ? 28n : 27n;
    const s = yParityAndS_bytes;
    if (v === 28n) s[0] &= 127;
    return {
      r,
      s: (0, toHex_js_1.bytesToHex)(s),
      v
    };
  }
  exports.compactSignatureToSignature = compactSignatureToSignature;
  //# sourceMappingURL=compactSignatureToSignature.js.map
  return exports;
}